export default "__VITE_PUBLIC_ASSET__1808b9ef__"